package ru.villawonka.app.presentation.screens.variantPicker.compose.view

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.material.MaterialTheme
import androidx.compose.material.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import ru.villawonka.app.presentation.design.components.AppRadioButton
import ru.villawonka.app.presentation.design.extensions.AppSpacer
import ru.villawonka.app.presentation.design.theme.AppTextStyles
import ru.villawonka.app.presentation.design.theme.onSurfacePrimary
import ru.villawonka.app.presentation.design.theme.onSurfaceSecondary

@Composable
internal fun VariantPickerItemView(
    title: String,
    subtitle: String? = null,
    selected: Boolean,
    onClick: () -> Unit,
) {
    Row(
        verticalAlignment = Alignment.CenterVertically,
        modifier = Modifier
            .fillMaxWidth()
            .clickable(
                indication = null,
                interactionSource = null,
                onClick = onClick,
            )
    ) {
        AppRadioButton(
            selected = selected,
            onClick = null,
        )
        AppSpacer(12.dp)
        Column {
            Text(
                text = title,
                style = AppTextStyles.bodyMediumMedium,
                color = MaterialTheme.colors.onSurfacePrimary,
            )
            subtitle?.let {
                AppSpacer(2.dp)
                Text(
                    text = it,
                    style = AppTextStyles.bodySmallRegular,
                    color = MaterialTheme.colors.onSurfaceSecondary,
                )
            }
        }

    }
}